import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/index'
import YoungCraftsMen from '@/views/youngCraftsMen/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: Layout
  },
  {
    path: '/youngCraftsmen',
    component: YoungCraftsMen
  },
  {
    path: '/collegiateSports',
    component: () => import(/* webpackChunkName: "login" */ '@/views/sport/collegiateSports')
  },
  { // 文章详情页
    path: '/collegiateSports/detail',
    component: () => import(/* webpackChunkName: "Detail" */ '@/views/sport/SportDetail')
  },
  // 用户编辑页面
  {
    path: '/user_info',
    component: () => import(/* webpackChunkName: "userInfo" */ '@/views/user/userInfo')
  },
  { // 文章详情页
    path: '/detail'
    // component: () => import(/* webpackChunkName: "Detail" */ '@/views/login/index')
    // component: () => import(/* webpackChunkName: "Detail" */ '@/views/articledetail')
  },
  {
    path: '/qzlx2025',
    component: () => import('@/views/qzlx2025/index')
  },
  {
    path: '/qzlx2025/login',
    component: () => import('@/views/qzlx2025/login')
  },
  {
    path: '/qzlx2025/submission',
    component: () => import('@/views/qzlx2025/submission')
  },
  {
    path: '/qzlx2025/addRecord',
    component: () => import('@/views/qzlx2025/addRecord')
  },
  {
    path:'/qzlx2025/detailRecord',
    component: () => import('@/views/qzlx2025/detailRecord')
  },
  {
    path: '/qzlx2026',
    component: () => import('@/views/qzlx2026/index')
  },
  {
    path: '/qzlx2026/login',
    component: () => import('@/views/qzlx2026/login')
  },
  {
    path: '/qzlx2026/submission',
    component: () => import('@/views/qzlx2026/submission')
  },
  {
    path: '/qzlx2026/addRecord',
    component: () => import('@/views/qzlx2026/addRecord')
  },
  {
    path:'/qzlx2026/detailRecord',
    component: () => import('@/views/qzlx2026/detailRecord')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: '/collectsys',
  routes
})
// 监听路由变化
router.afterEach((to, from, next) => {
  queueMicrotask(() => {
    if(navigator.userAgent.toLowerCase().indexOf('peopleplus_') == -1&&!!window.aplus_queue){
        aplus_queue.push({
            'action':'aplus.sendPV',
            'arguments':[{
                is_auto: false
            }, {
                "page_title": document.title||"人民网+",
                "current_page_name": document.title||"人民网+",
                "current_page_id": "home_pg",
                "current_channel_name": "人民网+",
                "event_type": "pageview",
                "event_code": "home_pg",
                "page_name": "home_pg" 
            }]
        });
    }
  })
})
export default router
